import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { Settings2 } from "lucide-react";
import { useAuth } from "@/AuthContext";
import WidgetGridBuilder from "@/components/WidgetGridBuilder";
import { SalarieWidgetLiveBody } from "@/components/widget-bodies/SalarieWidgetLiveBody";
import { PushSettingsToggle, SnoozeSettings } from "@/components/PushNotifications";

export default function SalarieDashboard() {
  const { user } = useAuth();
  const [catalog, setCatalog] = useState([]);
  const [prefs, setPrefs] = useState({});
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/salarie/widgets/catalog").then((r) => setCatalog(r.data.widgets || [])).catch(() => {});
    api.get("/salarie/widgets/preferences").then((r) => setPrefs(r.data.preferences || {})).catch(() => {});
    api.get("/salarie/widgets/data").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const enabledMap = React.useMemo(() => {
    const m = {};
    catalog.forEach((w) => { m[w.key] = !!prefs[w.key]?.enabled; });
    return m;
  }, [catalog, prefs]);
  const anyEnabled = Object.values(enabledMap).some(Boolean);

  return (
    <div className="min-h-full">
      <PageHeader
        eyebrow="Mon espace"
        title={`Bonjour ${user?.prenom || ""}`}
        sub="Vos informations essentielles, à votre façon."
        right={
          <Link to="/salarie/dashboard-settings" data-testid="salarie-dashboard-settings-btn" className="inline-flex items-center h-10 px-4 border border-[#DEE2E6] hover:border-[#0A0A0A] text-xs uppercase tracking-[0.2em] font-bold transition-colors">
            <Settings2 className="h-4 w-4 mr-2" /> Personnaliser
          </Link>
        }
      />
      <div className="p-6 lg:p-10" data-testid="salarie-widgets-grid">
        {!anyEnabled ? (
          <EmptyState />
        ) : (
          <WidgetGridBuilder
            catalog={catalog}
            enabledMap={enabledMap}
            prefs={prefs}
            readOnly
            testidPrefix="salarie"
            renderBody={(widget) => <SalarieWidgetLiveBody widget={widget} data={data?.[widget.key]} />}
          />
        )}
        <div className="mt-6 max-w-md space-y-3">
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#868E96] font-semibold mb-2">Alertes instantanées</div>
          <PushSettingsToggle />
          <SnoozeSettings />
        </div>
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="bg-white border border-dashed border-[#DEE2E6] p-10 text-center" data-testid="salarie-widgets-empty">
      <Settings2 className="h-10 w-10 mx-auto text-[#868E96] mb-3" />
      <div className="font-display font-bold text-lg mb-1">Votre dashboard est vide</div>
      <p className="text-sm text-[#868E96] mb-4">Activez au moins un widget pour personnaliser votre vue.</p>
      <Link to="/salarie/dashboard-settings" data-testid="salarie-widgets-empty-cta" className="inline-flex items-center h-10 px-5 bg-[#0A0A0A] text-white text-xs uppercase tracking-[0.2em] font-bold">
        Personnaliser mon dashboard
      </Link>
    </div>
  );
}
